import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import ServicesSection from '@/components/ServicesSection';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

export default function Index() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#services') {
      setTimeout(() => {
        document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Bonjour Sobrancelhas — Design e Micropigmentação em Guarulhos"
        description="Especialistas em design de sobrancelhas e micropigmentação em Guarulhos. Agende seu horário online e realce sua beleza natural."
        path="/"
      />
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ServicesSection />
      </main>
      <Footer />
    </div>
  );
}
